import { Modal } from "bootstrap";
import elementExists from "../core/utils/element-exists";

const FaqsFilter = function () {
  const filters = document.querySelectorAll( '.faq-categories-filter');
  const filtersMobile = document.querySelectorAll( '.filter-mobile');
  const accordion = document.querySelector( '#faq-accordion');
  const filterFaqs = function( filter ){
    const items = accordion.querySelectorAll( '.accordion-item');
    items.forEach( item => {
      if( item.dataset.tags.includes( filter ) ) {
        item.classList.remove( 'd-none')
      }else{
        item.classList.add( 'd-none')
      }
    })    
  }

  if( elementExists( filters , true ) && elementExists( accordion )){
    filters.forEach( filter => {
      const modalEl = filter.closest( '.modal');
      const anchors = filter.querySelectorAll( 'a');
      let parents = filter.querySelectorAll('.has-children--link');
      anchors.forEach( anchor => {
        anchor.addEventListener( 'click', function(e)  {
          e.preventDefault();
          if( elementExists( modalEl )){
            if ( anchor.getAttribute('class') != 'header-5 has-children--link' ) {
              // const btnClose = modalEl.querySelector( '.btn-close');
              var modal = Modal.getInstance(modalEl) // Returns a Bootstrap modal instance
              modal.hide();
            }
          }
          anchors.forEach( _anchor => {
            _anchor.classList.remove( 'active')
          })
          const data = e.currentTarget.dataset
          if( data.filter ){
            parents.forEach(parent => {
              parent.classList.add('collapsed');
            });
            e.currentTarget.classList.add( 'active');
            filterFaqs( data.filter );
          }
        });
      })
    })
  }
}
  

export default FaqsFilter;